import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'coin-v2-dialog-footer',
  templateUrl: './v2-dialog-footer.component.html',
  styleUrl: './v2-dialog-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  host: {
    role: 'contentinfo',
    '[class]': 'className()'
  }
})
export class V2DialogFooterComponent {
  color = input<FooterStyle>('gradient');
  padding = input<FooterPadding>('default');
  rounding = input<FooterRounding>('default');
  gap = input<FooterGap>('default');

  className = computed(() => {
    return `footer-${this.color()} padding-${this.padding()} rounding-${this.rounding()} gap-${this.gap()}`;
  });
}

export const FOOTER_STYLES = ['white', 'gradient'] as const;
export type FooterStyle = (typeof FOOTER_STYLES)[number];

export const FOOTER_PADDINGS = ['none', 'default', 'large'] as const;
export type FooterPadding = (typeof FOOTER_PADDINGS)[number];

export const FOOTER_ROUNDINGS = ['none', 'default'] as const;
export type FooterRounding = (typeof FOOTER_ROUNDINGS)[number];

export const FOOTER_GAPS = ['default', 'large'] as const;
export type FooterGap = (typeof FOOTER_GAPS)[number];
